class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    $(document).mouseup(function (e) {
      var container = $("cart-drawer");
      var navDrawer = $("#NavDrawer");

      if (!container.is(e.target) && container.has(e.target).length === 0 && !navDrawer.is(e.target) && !navDrawer.has(e.target).length) {
        container.show();
        $('cart-drawer').removeClass('active');
        $('body').removeClass('drawer__open');
        $('html').removeClass('no-scroll');
      }
    });

    $(document).ready(function () {
      $(document).on("click", "#applyDiscount", function (e) {
        e.preventDefault();
        const discountCode = $("#discountCode").val().trim();
    
        if (!discountCode) {
          showDiscountMessage("Please enter a discount code.", "error");
          return;
        }
    
        $.ajax({
          type: "GET",
          url: `/cart.js`,
          dataType: "json",
          success: function (cart) {
            if (cart.items.length > 0) {
              sessionStorage.setItem("discountApplied", "true");
              window.location.href = `/discount/${discountCode}`;
            } else {
              showDiscountMessage("Your cart is empty. Add items to apply a discount.", "error");
            }
          },
          error: function () {
            showDiscountMessage("Failed to check your cart. Please try again.", "error");
          },
        });
      });
    
      if (sessionStorage.getItem("discountApplied") === "true") {
        sessionStorage.removeItem("discountApplied");
        openCartDrawer();
      }
    
      function openCartDrawer() {
        $(".cart__drawer").addClass("show-cart__drawer");
        updateCartDrawer();
      }
    
      function updateCartDrawer() {
        $.ajax({
          url: "/cart",
          type: "GET",
          dataType: "html",
          success: function (response) {
            $(".cart__drawer").html($(response).filter(".cart__drawer").html());
          },
        });
      }
    
      function showDiscountMessage(message, type) {
        const $message = $("#discountMessage");
        $message.text(message).removeClass("error success").addClass(type).fadeIn();
        setTimeout(() => $message.fadeOut(), 3000);
      }
    
      $(document).on("click", "#removeDiscount", function () {
        removeDiscount();
      });
    
      function removeDiscount() {
        $.ajax({
          type: "GET",
          url: `/cart.js`,
          dataType: "json",
          success: function (cart) {
            if (cart.items.length > 0) {
              sessionStorage.setItem("discountApplied", "true");
              window.location.href = `/discount/&nbsp;`;
            }
          },
          error: function () {
            console.log("Failed to check your cart. Please try again.", "error");
          },
        });
      }
    });

    $(document).on('click', '.drawer__footer-discount-title p', function() {
      if($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $(this).addClass('active');
      }
    
      $(this).closest('.drawer__footer-discount').find('.drawer__footer-discount-form').slideToggle(300);
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.querySelector('html').classList.add('no-scroll');
    document.body.classList.add('drawer__open');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.querySelector('html').classList.remove('no-scroll');
    document.body.classList.remove('drawer__open');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
